import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';

function PrivateRoute({ children }: any) {
  const auth = localStorage.getItem('auth');
  return auth ? children : <Navigate to="/" />;
}

PrivateRoute.prototype = {
  children: PropTypes.element,
};

export default PrivateRoute;
